// extracted by mini-css-extract-plugin
export default {"confirmation-modal":"components-settings-budget-forecast-modals-modal-delete-entry-module__confirmation-modal"};